import { createStore } from 'vuex'
import createPersistedState from "vuex-persistedstate";
import { 
    ToastType, 
    createSuccessToast, 
    createErrorToast,
    autoCreateToast 
} from './utils/toast';
import chatModule from './store/chat';

const store =  createStore({
    modules: {
        chat: chatModule,
    },
    state: {
        user: {
            email: ''
        },
        isAuthenticated: false,
        token: '',
        toast: {
            show: false,
            message: '',
            type: ToastType.ERROR
        }
    },
    mutations: {
        setToken(state, token) {
            state.token = token
            state.isAuthenticated = true
        },
        removeToken(state) {
            state.token = ''
            state.isAuthenticated = false
        },
        showToast(state, { message, type = ToastType.ERROR }) {
            state.toast = { show: true, message, type }
        },
        hideToast(state) {
            state.toast.show = false
        }
    },
    actions: {
        showSuccessToast({ commit }, message) {
            commit('showToast', { message, type: ToastType.SUCCESS });
        },
        showErrorToast({ commit }, message) {
            commit('showToast', { message, type: ToastType.ERROR });
        },
        showWarningToast({ commit }, message) {
            commit('showToast', { message, type: ToastType.WARNING });
        },
        showInfoToast({ commit }, message) {
            commit('showToast', { message, type: ToastType.INFO });
        },
        showToastFromResponse({ commit }, { response, error, customMessage = null }) {
            if (error) {
                const toast = createErrorToast(error);
                if (customMessage) toast.message = customMessage;
                commit('showToast', toast);
            } else {
                const toast = createSuccessToast(response, customMessage);
                commit('showToast', toast);
            }
        },
        showToastFromError({ commit }, error) {
            const toast = createErrorToast(error);
            commit('showToast', toast);
        },
        showToastFromSuccess({ commit }, response, customMessage = null) {
            const toast = createSuccessToast(response, customMessage);
            commit('showToast', toast);
        }
    },
    plugins: [createPersistedState({
        paths: ['user', 'isAuthenticated', 'token']
    })]
});

export { ToastType };
export default store
